// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BranchSelectorPPL__close{align-items:center;background:#fff;border:1px solid #dee2e6;border-radius:50%;color:#124c86;cursor:pointer;display:flex;height:48px;justify-content:center;padding:0;position:fixed;right:28px;top:26px;width:48px;z-index:1000000}.BranchSelectorPPL__close:focus,.BranchSelectorPPL__close:hover{color:#0c3359}.BranchSelectorPPL__closeIcon{fill:currentColor;height:20px;width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
